import { render, staticRenderFns } from "./IntelligentTrain.vue?vue&type=template&id=b05dfd34&scoped=true&"
import script from "./IntelligentTrain.vue?vue&type=script&lang=js&"
export * from "./IntelligentTrain.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentTrain.vue?vue&type=style&index=0&id=b05dfd34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05dfd34",
  null
  
)

export default component.exports